<template>
  <vs-popup fullscreen :title="title" :active.sync="popupActiveLocal">
      <ag-grid-vue
          ref="popupDetails"
          :gridOptions="gridOptions"
          class="ag-theme-material w-100 my-4 ag-grid-table"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowData="items"
          colResizeDefault="shift"
          :animateRows="true"
          :pagination="false"
          :suppressPaginationPanel="true"
          :enableRtl="$vs.rtl">
      </ag-grid-vue>
  </vs-popup>
</template>
<script>
import { AgGridVue } from "@ag-grid-community/vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'

export default {
  props: {
      data: {
          type: Array,
          required: true
      },
      popupActive: {
          type: Boolean,
          required: true
      },
      title: {
          type: String,
          required: true
      }
  },
  data() {
      return {
          gridOptions: {
              alignedGrids: [],
              suppressHorizontalScroll: true,
          },
          defaultColDef: {
              sortable: true,
              editable: false,
              resizable: true,
              suppressMenu: true
          },
          columnDefs: [
              {
                headerName: 'ID',
                field: 'id_digital_payment_transaction',
                filter: true,
                width: 120,
                // hide: this.$acl.check('school')
              },
              // {
              //   headerName: 'Servicio',
              //   field: 'name_service',
              //   filter: true,
              // },
              {
                  headerName: "Estudiante",
                  field: "student_display_name",
                  width: 240,
                  filter: true,
                  cellClass: "cellMayusc",
              },
              {
                  headerName: "Acudiente",
                  field: "guardian_display_name",
                  width: 240,
                  filter: true,
                  cellClass: "cellMayusc",
              },
              {
                headerName: 'Cuota',
                field: 'expiration_date',
                filter: true,
              },
              {
                  headerName: 'Fecha de pago',
                  field: 'payment_date',
                  filter: false,
                  width: 150,
              },
              {
                headerName: 'Monto',
                field: 'base_amount',
                filter: true,
                valueFormatter: params => this.$options.filters.currencySign(params.data.base_amount, '$ '),
              },
              {
                headerName: "Recargo",
                field: "surcharges_amount",
                width: 150,
                filter: true,
                valueFormatter: params => this.$options.filters.currencySign(params.data.surcharges_amount ? params.data.surcharges_amount : 0, '$ '),
              },
              {
                headerName: "Descuento",
                field: "discounts_amount",
                width: 150,
                filter: true,
                valueFormatter: params => this.$options.filters.currencySign(params.data.discounts_amount ? params.data.discounts_amount : 0, '$ '),
              },
              {
                headerName: 'Total',
                field: 'final_amount_payer',
                filter: true,
                valueFormatter: params => this.$options.filters.currencySign(params.data.final_amount_payer, '$ '),
                valueGetter: params => {
                    return params.data.final_amount_payer
                }
              },
          ],
          // popupActiveLocal: JSON.parse(this.popupActive)
      }
  },
  components: {
      AgGridVue,
  },
  computed: {
      popupActiveLocal: {
          get() {
              return JSON.parse(this.popupActive)
          },
          set() {
              this.$emit('updatePopupActive')
          }
      },
      items() {
          return this.data
      }
  },
}
</script>
